// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getTiposSolicitantes as listTiposSolicitantesAPI,
    getTipoSolicitante as getTiposSolicitanteAPI,
    addTiposSolicitante as addTiposSolicitanteAPI,
    updateTiposSolicitante as updateTiposSolicitanteAPI,
    updateOrderTiposSolicitante as updateOrderTiposSolicitanteAPI,
    deleteTiposSolicitante as deleteTiposSolicitanteAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { tiposSolicitantesApiResponseError, tiposSolicitantesApiResponseSuccess } from './actions';
import { TiposSolicitantesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getTipoSolicitante({ payload: { id } }) {
    try {
        const response = yield call(getTiposSolicitanteAPI, id );
        const tiposSolicitanteItem = response.data.data;
        yield put(tiposSolicitantesApiResponseSuccess(TiposSolicitantesActionTypes.GET_TIPO, tiposSolicitanteItem));
    } catch (error) {
        yield put(tiposSolicitantesApiResponseError(TiposSolicitantesActionTypes.GET_TIPO, error));
    }
}

function* addTiposSolicitante({payload:tiposSolicitante}){
    try{
        const response = yield call(addTiposSolicitanteAPI,{...tiposSolicitante})
        const tiposSolicitanteItem = response.data
        yield put(tiposSolicitantesApiResponseSuccess(TiposSolicitantesActionTypes.ADD_TIPO,tiposSolicitanteItem))
    } catch(error){
        yield put(tiposSolicitantesApiResponseError(TiposSolicitantesActionTypes.ADD_TIPO,error))
    }
}

function* updateTiposSolicitante({payload:tiposSolicitante}){
    try{
        const response = yield call(updateTiposSolicitanteAPI,{...tiposSolicitante})
        const tiposSolicitanteItem = response.data.data
        yield put(tiposSolicitantesApiResponseSuccess(TiposSolicitantesActionTypes.UPDATE_TIPO,tiposSolicitanteItem))
    }catch(error){
        yield put(tiposSolicitantesApiResponseError(TiposSolicitantesActionTypes.UPDATE_TIPO,error))
    }
}

function* updateOrderTiposSolicitante({payload:tiposSolicitante}){
    try{
        const response = yield call(updateOrderTiposSolicitanteAPI,{...tiposSolicitante})
        const tiposSolicitanteItem = response.data.data
        yield put(tiposSolicitantesApiResponseSuccess(TiposSolicitantesActionTypes.UPDATE_ORDER_TIPOS,tiposSolicitanteItem))
    }catch(error){
        yield put(tiposSolicitantesApiResponseError(TiposSolicitantesActionTypes.UPDATE_ORDER_TIPOS,error))
    }
}


function* deleteTiposSolicitante({payload:{id}}){
    try{
        const response = yield call(deleteTiposSolicitanteAPI,id)
        const tiposSolicitanteItem = response.data.id
        yield put(tiposSolicitantesApiResponseSuccess(TiposSolicitantesActionTypes.DELETE_TIPO,tiposSolicitanteItem))
    }catch(error){
        yield put(tiposSolicitantesApiResponseError(TiposSolicitantesActionTypes.DELETE_TIPO,error))
    }
}

/**
 * List contactos
 */
function* listTiposSolicitantes({payload:params}) {
    try {
        const response = yield call(listTiposSolicitantesAPI, { ...params });
        const listaTiposSolicitantes = response.data.data;
        yield put(tiposSolicitantesApiResponseSuccess(TiposSolicitantesActionTypes.LIST_TIPOS, listaTiposSolicitantes));
    } catch (error) {
        yield put(tiposSolicitantesApiResponseError(TiposSolicitantesActionTypes.LIST_TIPOS, error));
    }
}


export function* watchGetTiposSolicitante(): any {
    yield takeEvery(TiposSolicitantesActionTypes.GET_TIPO, getTipoSolicitante);
}

export function* watchListTiposSolicitantes(): any {
    yield takeEvery(TiposSolicitantesActionTypes.LIST_TIPOS, listTiposSolicitantes);
}

export function* watchAddTiposSolicitante():any{
    yield takeEvery(TiposSolicitantesActionTypes.ADD_TIPO,addTiposSolicitante)
}
export function* watchUpdateTiposSolicitante():any{
    yield takeEvery(TiposSolicitantesActionTypes.UPDATE_TIPO,updateTiposSolicitante)
}
export function* watchUpdateOrderTiposSolicitante():any{
    yield takeEvery(TiposSolicitantesActionTypes.UPDATE_ORDER_TIPOS,updateOrderTiposSolicitante)
}
export function* watchDeleteTiposSolicitante():any{
    yield takeEvery(TiposSolicitantesActionTypes.DELETE_TIPO,deleteTiposSolicitante)
}


function* tiposSolicitantesSaga(): any {
    yield all([
        fork(watchGetTiposSolicitante),
        fork(watchListTiposSolicitantes),
        fork(watchAddTiposSolicitante),
        fork(watchUpdateTiposSolicitante),
        fork(watchUpdateOrderTiposSolicitante),
        fork(watchDeleteTiposSolicitante),
    ]);
}

export default tiposSolicitantesSaga;
